import type { SupabaseClient } from "@supabase/supabase-js";
import type {
  Database,
  PurchaseEventInsert,
} from "@/integrations/supabase/supabaseTypes";

export interface PurchaseEventInput {
  readonly ownerId: string;
  readonly provider: string;
  readonly productId: string;
  readonly eventType: string;
  readonly status?: string;
  readonly amountMinor?: number | null;
  readonly currencyCode?: string | null;
  readonly providerEventId?: string | null;
  readonly rawPayload?: PurchaseEventInsert["raw_payload"];
}

export interface PurchaseEventRepository {
  record(input: PurchaseEventInput): Promise<void>;
}

export function createSupabasePurchaseEventRepository(
  client: SupabaseClient<Database>,
): PurchaseEventRepository {
  return {
    async record(input) {
      const insert: PurchaseEventInsert = {
        owner_id: input.ownerId,
        provider: input.provider,
        product_id: input.productId,
        event_type: input.eventType,
        status: input.status ?? "completed",
        amount_minor: input.amountMinor ?? null,
        currency_code: input.currencyCode ?? null,
        provider_event_id: input.providerEventId ?? null,
        raw_payload: input.rawPayload ?? {},
      };
      const result = await client.from("purchase_events").insert(insert);
      if (result.error) {
        throw new Error(
          `Failed to insert purchase_events for owner ${input.ownerId}: ${result.error.message}`,
        );
      }
    },
  };
}

export function createNoopPurchaseEventRepository(): PurchaseEventRepository {
  return {
    async record() {
      // no-op for environments without Supabase configured.
    },
  };
}
